import Game from "../../Game.js";
import Styler from "../../maze/featurer/Styler.js";
import Spran from "../spran/Spran.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";

export default class Column extends Mob {
	constructor(sprites, type, style) {
		//Column.ANIMATIONS[0].sheet = "columns" + style;
		//Column.ANIMATIONS[1].sheet = "columns" + style;
		super(sprites, Column.ANIMATIONS);
		this.width = Game.COLUMN_WIDTH;
		this.height = Game.COLUMN_HEIGHT;
		this.style = style;
		this.type = type;

		let traits = {
			clas: "column",
			openDoors: false,
			static: true,
			qi: BasicAI.QI_NONE,
			speed: Mob.WALK_STEP * Game.MULT,
			radius: Mob.RADIUS,
			runspeed: Mob.RUN_STEP * Game.MULT
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-static").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}


	initSprites() {
		// Setta la grandezza dello sprite
		this.clip = jQuery(".js-sprite", this.mc);

		this.clip.width(Game.COLUMN_WIDTH);
		this.clip.height(Game.COLUMN_HEIGHT * 2);

		// Lo posiziona, centrato orizzontalmente e appoggiato al bottom verticalmente
		//this.clip.css("left", (this.mc.width() - this.clip.width()) / 2);
		//this.clip.css("top", -(Game.TILE_WIDTH - this.mc.height()) - Game.TILE_WIDTH + Game.HERO_HEIGHT / 2);
		this.clip.css("top", -Game.COLUMN_HEIGHT);
		this.spran = new Spran(this.sp, this.clip, this.animationsDefinitions);
		this.spran.init();
		this.setAnimation("column" + (this.type-1));

	}

}

Column.ANIMATIONS = [
	{
		id: "column0",
		sheet: Styler.COLUMNS,
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "column1",
		sheet: Styler.COLUMNS,
		flip: false,
		frames: [
			{
				row: 0,
				col: 1,
				time: -1
			}
		]
	},
]